// Authentication Service - Manages user sessions via PostgreSQL
import { apiCall } from '../config/postgres';

export const authService = {
  // Login user (supports admin, teacher, student)
  login: async (username, password, userType = 'admin') => {
    try {
      const response = await apiCall('/api/auth/login', {
        method: 'POST',
        body: JSON.stringify({ username, password, userType }),
      });
      
      // Store token in sessionStorage (cleared on browser close) instead of localStorage
      if (response.token) {
        sessionStorage.setItem('safir_auth_token', response.token);
        sessionStorage.setItem('safir_user', JSON.stringify(response.user));
        sessionStorage.setItem('safir_user_type', response.user.role || userType);
      }
      
      return response;
    } catch (error) {
      console.error('Login failed:', error);
      throw error;
    }
  },

  // Logout user
  logout: async () => {
    try {
      // Clear session storage
      sessionStorage.removeItem('safir_auth_token');
      sessionStorage.removeItem('safir_user');
      
      // Optionally notify backend
      await apiCall('/api/auth/logout', {
        method: 'POST',
      }).catch(() => {
        // Ignore errors on logout
      });
      
      return true;
    } catch (error) {
      console.error('Logout failed:', error);
      // Still clear local session even if backend fails
      sessionStorage.removeItem('safir_auth_token');
      sessionStorage.removeItem('safir_user');
      return true;
    }
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    try {
      const token = sessionStorage.getItem('safir_auth_token');
      return !!token;
    } catch (error) {
      console.error('Error checking authentication:', error);
      return false;
    }
  },

  // Get current user
  getCurrentUser: () => {
    try {
      const userStr = sessionStorage.getItem('safir_user');
      return userStr ? JSON.parse(userStr) : null;
    } catch (error) {
      console.error('Error getting current user:', error);
      return null;
    }
  },

  // Get auth token
  getToken: () => {
    try {
      return sessionStorage.getItem('safir_auth_token');
    } catch (error) {
      console.error('Error getting auth token:', error);
      return null;
    }
  },

  // Verify token with backend
  verifyToken: async () => {
    try {
      const token = sessionStorage.getItem('safir_auth_token');
      if (!token) {
        return false;
      }

      const response = await apiCall('/api/auth/verify', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      return response.valid === true;
    } catch (error) {
      console.error('Token verification failed:', error);
      return false;
    }
  },
};
